<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {required} from "vuelidate/lib/validators";
import {vanBanDenModel} from "@/models/vanBanDenModel";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import vue2Dropzone from "vue2-dropzone";
import {vanBanDiModel} from "@/models/vanBanDiModel";
import {groupCongViecModel} from "@/models/QuanLyCongViec/groupCongViecModel";

export default {
  page: {
    title: "Quản lý công việc",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Nhóm công việc",
      data: [],
      showModal: false,
      submitted: false,
      model: groupCongViecModel.baseJson(),
      optionsUser: [],
      optionsTrangThai: [],
      showButtonSave: false,
      isShow: false,
      code: null,
    };
  },
  validations: {
    model: {
      name: {required},
      status: {required},
      users: {required},
    },
  },
  async created() {
    this.init();
    if (this.$route.params.id) {
      this.handleDetail();
    }
  },
  watch: {
  },
  methods: {
    init(){
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      Promise.all([ this.getUser(), this.getTrangThai()
      ]).then((values) => {
        loader.hide()
      });
    },
    async handleDetail() {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      await this.$store.dispatch("cvGroupStore/getById", this.$route.params.id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          this.model = res.data;
          this.showModal = true;
          loader.hide();
          this.showButtonSave = false;
        }
      });
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.model.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model.id != null &&
            this.model.id
        ) {
          //Update model
          await this.$store.dispatch("cvGroupStore/update", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.model = groupCongViecModel.baseJson()
              this.isShow = true;
              this.code = res;
            }
          })
        } else {
          //Create modelhandleSubmit
          this.model.version = 1;
          await this.$store.dispatch("cvGroupStore/create", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.model = groupCongViecModel.baseJson();
              this.isShow = true;
              this.code = res;
            }
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    async getTrangThai() {
      try {
        await this.$store.dispatch("trangThaiStore/getNextTrangThai", {
          loaiTrangThai: "CVGROUP",
        }).then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data;
            this.loading = false
            this.optionsTrangThai = items;
            if(this.model.status == null){
              var newItem = this.optionsTrangThai.find(x => x.code == "GroupCV_NEW");
              this.model.status = newItem;
            }
            return items || []
          }
          return [];
        })
      } finally {
        this.loading = false
      }
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
            this.canBoSoan = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    handleHideModal() {
      this.isShow = false;
      this.$router.push('/quan-ly-cong-viec')
    },
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="handleSubmit"
                  ref="formContainer">
              <div class="row">
                <div class="col-md-7">
                  <div style="display: flex;justify-content: space-between">
                    <div class="">
                      <PageHeader :title="title"/>
                    </div>
                    <div class="">
                      <div class="text-end">
                        <b-button type="submit" variant="primary" class="ms-1" style="width: 80px"
                                  size="sm"
                                  @click="handleSubmit"
                        >
                          Lưu
                        </b-button>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <!-- Tên công việc -->
                    <div class=" col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01"> Tên công việc</label>
                        <textarea
                            id="validationCustom01"
                            v-model="model.name"
                            type="text"
                            class="form-control"
                            placeholder=""
                            rows="3"
                        > </textarea>
                        <div
                            v-if="submitted && !$v.model.name.required"
                            class="invalid-feedback"
                        >
                          Tên công việc không được để trống.
                        </div>
                      </div>
                    </div>

                    <!-- Người tham gia -->
                    <div class="col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01"> Người tham gia</label>
                        <multiselect
                            v-model="model.users"
                            :options="optionsUser"
                            track-by="id"
                            label="fullName"
                            placeholder="Chọn người tham gia"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                            multiple=true
                        >
                          <template slot="singleLabel" slot-scope="{ option }">
                            <strong>{{ option.fullName }}</strong>

                            <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                          </template>
                          <template slot="option" slot-scope="{ option }">
                            <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                              <span v-if="option.donVi" class="option__small"
                                    style="color:green">{{ option.donVi.ten }}</span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>

                    <!-- Trạng thái-->
                    <div class="col-12">
                      <div class="mb-2">
                        <label class="form-label" for="validationCustom01">Trạng thái tiếp theo</label> <span
                          class="text-danger">*</span>
                        <multiselect
                            v-model="model.status"
                            :options="optionsTrangThai"
                            track-by="code"
                            label="ten"
                            placeholder="Chọn trạng thái"
                            deselect-label="Nhấn để xoá"
                            selectLabel="Nhấn enter để chọn"
                            selectedLabel="Đã chọn"
                            :class="{
                                'is-invalid':
                                  submitted && $v.model.status.$error,
                                }"
                        ></multiselect>
                        <div
                            v-if="submitted && !$v.model.status.required"
                            class="invalid-feedback"
                        >
                          Trạng thái không được để trống.
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </form>
            <b-modal
                v-model="isShow"
                title="Thông tin lĩnh vực"
                title-class="text-black font-18"
                body-class="p-3"
                hide-footer
                hide-header
                centered
                no-close-on-backdrop
                size="md"
                style="padding: 0px"
            >
              <Transition name="fade" mode="out-in">
                <div class="row justify-content-center">
                  <div class="col-md-12"
                       style="display: flex; justify-content: center; align-items: center; padding: 40px 40px; flex-direction: column;">
                    <div class="success-checkmark">
                      <div class="check-icon">
                        <span class="icon-line line-tip"></span>
                        <span class="icon-line line-long"></span>
                        <div class="icon-circle"></div>
                        <div class="icon-fix"></div>
                      </div>
                    </div>
                    <h1 v-if="code" class="fw-bold fs-3 text-dark text-uppercase">{{ code.resultString }}</h1>
                    <button type="button" v-on:click="handleHideModal" class="btn btn-modal text-uppercase"
                            style="width: 200px; margin-top: 20px; border-radius: 30px">Đồng ý
                    </button>
                  </div>
                </div>
              </Transition>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.title-capso {
  font-weight: bold;
  color: #00568C;

}

.content-capso {
  color: #00568C;
  padding-left: 10px;
}

.capso-container {
  margin-top: 10px;
  display: flex;
  padding: 0px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}
</style>
<style lang="scss">
.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;

  .check-icon {
    width: 80px;
    height: 80px;
    position: relative;
    border-radius: 50%;
    box-sizing: content-box;
    border: 4px solid #4CAF50;

    &::before {
      top: 3px;
      left: -2px;
      width: 30px;
      transform-origin: 100% 50%;
      border-radius: 100px 0 0 100px;
    }

    &::after {
      top: 0;
      left: 30px;
      width: 60px;
      transform-origin: 0 50%;
      border-radius: 0 100px 100px 0;
      animation: rotate-circle 4.25s ease-in;
    }

    &::before, &::after {
      content: '';
      height: 100px;
      position: absolute;
      background: #FFFFFF;
      transform: rotate(-45deg);
    }

    .icon-line {
      height: 5px;
      background-color: #4CAF50;
      display: block;
      border-radius: 2px;
      position: absolute;
      z-index: 10;

      &.line-tip {
        top: 46px;
        left: 14px;
        width: 25px;
        transform: rotate(45deg);
        animation: icon-line-tip 0.75s;
      }

      &.line-long {
        top: 38px;
        right: 8px;
        width: 47px;
        transform: rotate(-45deg);
        animation: icon-line-long 0.75s;
      }
    }

    .icon-circle {
      top: -4px;
      left: -4px;
      z-index: 10;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      position: absolute;
      box-sizing: content-box;
      border: 4px solid rgba(76, 175, 80, .5);
    }

    .icon-fix {
      top: 8px;
      width: 5px;
      left: 26px;
      z-index: 1;
      height: 85px;
      position: absolute;
      transform: rotate(-45deg);
      background-color: #FFFFFF;
    }
  }
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}

@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

.btn-modal {
  background: #00568C;
  border: none;
  color: #fff;
}

.btn-modal:hover {
  background: #00568C;
  border: none;
  color: #fff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
}
.main-content{
  overflow: visible;
}
</style>
